module.exports = "https://cdn.realtymogul.com/static/media/icon_wallet.3da5f49f.svg";